export default __webpack_public_path__ + "static/media/minePic.94b7bb93.jpg";